import React from 'react';

const IconScholar = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    role="img"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round">
    <title>Google Scholar</title>
    <path d="M12 3 1 9l11 6 9-4.91V17h2V9z" />
    <path d="M5 13.18v4L12 21l7-3.82v-4" />
  </svg>
);

export default IconScholar;
